import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const ERRORS = {
  forbidden: "That Google account isn't authorized for this CRM.",
  google: "Google sign-in failed. Try again.",
  missing_code: "Google sign-in was cancelled.",
  expired: "Google sign-in took too long. Try again.",
};

export default function LoginPage() {
  const { isLoggedIn, login, loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [config, setConfig] = useState({ google: false, password: true });
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Google OAuth callback redirects back here as /login#token=... (success;
  // a fragment, so the token never hits a server log) or /login?error=...
  // (denied). Capture the token and enter the app.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    const err = params.get("error");
    if (token) {
      loginWithToken(token);
      navigate("/", { replace: true });
      return;
    }
    if (err) setError(ERRORS[err] || "Sign-in failed.");
    fetch("/api/auth/config")
      .then((r) => r.json())
      .then(setConfig)
      .catch(() => {});
  }, [loginWithToken, navigate]);

  useEffect(() => {
    if (isLoggedIn) navigate("/", { replace: true });
  }, [isLoggedIn, navigate]);

  const handlePassword = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="crm-login">
      <div className="crm-login__card">
        <div className="crm-logo">
          <img className="crm-logo__mark" src="/favicon.svg" alt="" style={{ width: 34, height: 34 }} />
          <span className="crm-logo__name" style={{ color: "var(--crm-black)" }}>
            <b style={{ fontSize: 18 }}>Remotion</b>
            <span style={{ color: "var(--crm-gray-600)" }}>CRM</span>
          </span>
        </div>
        <h1>Sign in</h1>

        {config.google && (
          <a className="crm-btn crm-btn--primary" href="/api/auth/google" style={{ display: "inline-block", textDecoration: "none" }}>
            Continue with Google
          </a>
        )}

        {config.password && (
          <>
            {config.google && <div className="crm-login__divider">or</div>}
            <form onSubmit={handlePassword}>
              <input
                type="password"
                placeholder="Dashboard password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button type="submit" className="crm-btn crm-btn--secondary" disabled={loading || !password}>
                {loading ? "Signing in…" : "Sign in with password"}
              </button>
            </form>
          </>
        )}

        {error && <p className="crm-login__err">{error}</p>}
      </div>
    </div>
  );
}
